module.exports = __webpack_public_path__ + "static/property3-27142c8d7d1419d420e77c1ded1083e1.png";